import { makeStyles } from '@material-ui/styles';

const CONTROL_BAR_HEAIGHT = 76;

export default makeStyles(theme => ({
  sendButton: {
    marginLeft: 20,
    fill: theme.palette.colors.teal,
    alignSelf: 'flex-end',
    [theme.breakpoints.up('mobile')]: {
      width: 180,
      fill: theme.palette.colors.white,
    },
  },
  controlBar: {
    minHeight: CONTROL_BAR_HEAIGHT,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: [13, 20],
    borderTop: `1px solid ${theme.palette.colors.border}`,
    flexGrow: 0,
    flexShrink: 0,
  },
  inputField: {
    width: '100%',
  },
  controlButtons: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/components/NewMessageField/useStyles.js